import './UserMenu.scss'

import { HDSAvatar } from '@here/hds-react-components'
import React from 'react'

import { i18n } from '../../../lib/i18n'

interface UserMenuSignup {
  onSignUp: () => void
}

export function UserMenuSignup(props: UserMenuSignup): JSX.Element {
  return (
    <>
      <HDSAvatar size="large" />
      <span className="UserMenu__text_link UserMenu__title" onClick={props.onSignUp}>
        {i18n('account.menu.action.create-account')}
      </span>
      <span className="UserMenu__subtitle">{i18n('account.menu.msg.collections-teaser')}</span>
    </>
  )
}
